import {
    Component,
    ElementRef,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {fromEvent, Observable, Subject, Subscription} from "rxjs";
import {
    AbstractControl,
    ControlValueAccessor,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR,
    UntypedFormBuilder,
    UntypedFormGroup, 
    ValidationErrors
} from "@angular/forms";
import {
    arrayIsSet,
    isNotNullOrUndefined,
    KeyStringValue,
    stringIsSet
} from "../../providers/service/global-variables.service";
import {TranslateService} from "@ngx-translate/core";
import {filter, map, startWith} from "rxjs/operators";
import {MatMenuTrigger} from "@angular/material/menu";

export interface PossibleValuesFormField {
    traductionSensorData?: string;
    traductionCustomSensorData?: string;
    noTraduction?: string;
    traduction?: string;
    registerValue: any;
    objectId: string;
    disabled?: boolean;
}

@Component({
    selector: 'app-multi-select-form-field',
    templateUrl: './multi-select-form-field.component.html',
    styleUrls: ['./multi-select-form-field.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: MultiSelectFormFieldComponent
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: MultiSelectFormFieldComponent
        }
    ],
    standalone: false
})
export class MultiSelectFormFieldComponent implements OnInit, OnChanges, OnDestroy, ControlValueAccessor {
    private subScriptions = new Subscription();
    @ViewChild(MatMenuTrigger) trigger?: MatMenuTrigger;
    @ViewChild('Containter') container?: ElementRef<HTMLDivElement>;
    public formGroup: UntypedFormGroup;
    @Output() emitValues = new Subject()
    @Input() appearance: 'fill' | 'outline' = "fill";
    @Input() labelSearch: string | undefined
    @Input() possibleValues: PossibleValuesFormField[] | undefined;
    @Input() disableClickOutside = false
    @Input() activedPossibleValues: KeyStringValue<boolean> | undefined;
    @Input() disabledPossibleValues: KeyStringValue<boolean> | undefined;
    @Input() multiple: boolean = true;
    @Input() showChipList: boolean = true;
    @Input() minWidth: number = 291;
    public showButtonShowDisabledItem = false;
    private subscripitonOptions: Subscription | undefined;

    public selectedChips$: Observable<PossibleValuesFormField[]>
    public filteredName$: Observable<string>
    public showNotActived$: Observable<boolean>
    widthContainer = 'calc(' + 500 + 'px - 0px)'
    getTraduction;
    labelSearch$: Observable<string>

    constructor(private fb: UntypedFormBuilder,
                private translateService: TranslateService) {
        this.formGroup = this.fb.group({
            name: '',
            registerValues: [],
            options: [],
            chips: [],
            showNotActived: false
        });
        this.selectedChips$ = (this.formGroup.get('chips') as any).valueChanges.pipe(
            startWith(this.selectedChips),
            map(() => this.selectedChips)
        )
        this.filteredName$ = (this.formGroup.get('name') as any).valueChanges.pipe(
            startWith(this.filteredName),
            map(() => this.filteredName)
        )
        this.showNotActived$ = (this.formGroup.get('showNotActived') as any).valueChanges.pipe(
            startWith(undefined),
            map(() => this.showNotActived)
        )
        this.getTraduction = (value: string) => this.translateService.instant(value)
        this.labelSearch$ = this.formGroup.get('chips')!.valueChanges.pipe(
            startWith(undefined),
            map((values: any[]) => {
                if (arrayIsSet(values) && !this.multiple) {
                    if (values[0].traduction) {
                        return this.getTraduction(values[0].traduction)
                    } else if (values[0].noTraduction) {
                        return values[0].noTraduction
                    } else if (values[0].objectId) {
                        return values[0].objectId
                    }

                } else if (stringIsSet(this.labelSearch)) {
                    return this.labelSearch
                } else {
                    return this.translateService.instant('search_generic');
                }
            })
        )
    }

    ngOnInit() {

        this.subScriptions.add(
            fromEvent(window, 'resize').pipe(
                filter(() => this.trigger?.menuOpen == true)
            )
                .subscribe(event => {
                    this.calcDimensionMenu()
                })
        )

    }

    calcDimensionMenu() {
        if (this.container) {
            this.widthContainer = 'calc(' + Math.max(this.container.nativeElement.clientWidth,this.minWidth) + 'px - 35px)';
        }
    }

    beforeOpenMenu(){
        this.calcDimensionMenu();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.subscripitonOptions == null) {
            this.subscripitonOptions = (this.formGroup.get('options') as any).valueChanges.pipe(
                startWith(undefined),
                map(() => (this.formGroup.get('options') as any).value)
            )
                .subscribe((options: any[]) => {
                    if (arrayIsSet(options)) {
                        let registerValues;
                        if (!arrayIsSet(this.possibleValues)) {
                            registerValues = options;
                            this.selectedChips = options.map((option: any) => {
                                const obj: PossibleValuesFormField = {
                                    traduction: option,
                                    registerValue: option,
                                    objectId: option
                                }
                                return obj;
                            })
                        } else {
                            registerValues = this.possibleValues
                                .filter(value => options.includes(value.objectId))
                                .map(value => value.registerValue);
                            this.selectedChips = this.possibleValues
                                .filter(value => options.includes(value.objectId))
                                .map(value => {
                                    const obj = {...value};
                                    delete obj.registerValue;
                                    return obj;
                                });
                        }
                        this.selectedRegisterValues = registerValues;
                    } else {
                        this.selectedRegisterValues = [];
                        this.selectedChips = [];
                    }

                    this.emitValues.next(this.selectedRegisterValues)
                });
        }
        if (changes.disabledPossibleValues != null || changes.activedPossibleValues != null) {
            this.showButtonShowDisabledItem = (this.activedPossibleValues != null && arrayIsSet(Object.keys(this.activedPossibleValues))) || (this.disabledPossibleValues != null && arrayIsSet(Object.keys(this.disabledPossibleValues)))
        }
        if (changes.possibleValues != null) {
            if (arrayIsSet(this.possibleValues)) {
                if (arrayIsSet(this.selectedOptions)) {
                    setTimeout(() => {
                        const currentItem = this.possibleValues?.map(value => value.objectId);
                        this.selectedOptions = this.selectedOptions?.filter(option => currentItem?.includes(option));
                    });
                }
            } else {
                this.formGroup.get('registerValues')?.reset();
            }
        }
    }

    ngOnDestroy() {
        this.subScriptions.unsubscribe()
        if (this.subscripitonOptions != null) {
            this.subscripitonOptions.unsubscribe();
        }
    }


    unsetValue() {
        this.formGroup.reset();
    }

    onTouched = () => {
    }


    registerOnChange(onChange: any) {
        const sub = this.formGroup.get('registerValues')?.valueChanges
            .subscribe(onChange);
        this.subScriptions.add(sub);
    }

    registerOnTouched(onTouched: any) {
        this.onTouched = onTouched;
    }


    setDisabledState(disabled: boolean) {
        if (disabled) {
            this.formGroup.disable();
        } else {
            this.formGroup.enable();
        }
    }


    writeValue(value: any[]) {
        if (!isNotNullOrUndefined(value)) {
            this.formGroup.reset();
        } else if (arrayIsSet(value)) {
            (this.formGroup.get('options') as any).setValue(value.map(val => (val.objectId) ? val.objectId : val));
        }
    }

    validate(control: AbstractControl): ValidationErrors | null {
        if (!isNotNullOrUndefined(this.formGroup.get('registerValues')?.validator)) {
            this.formGroup.get('registerValues')?.setValidators(control.validator);
        }
        if (this.formGroup.get('registerValues')?.valid) {
            return null;
        } else {
            return (this.formGroup.get('registerValues') as any).errors;
        }
    }

    get selectedRegisterValues(): PossibleValuesFormField[] {
        return this.formGroup.get('registerValues')?.value;
    }

    set selectedRegisterValues(values: PossibleValuesFormField[]) {
        this.formGroup.get('registerValues')?.setValue(values);
    }

    get selectedChips(): PossibleValuesFormField[] {
        return this.formGroup.get('chips')?.value;
    }

    set selectedChips(values: PossibleValuesFormField[]) {
        this.formGroup.get('chips')?.setValue(values);
    }

    get selectedOptions(): string[] {
        return this.formGroup.get('options')?.value;
    }


    set selectedOptions(values: string[]) {
        this.formGroup.get('options')?.setValue(values);
    }

    get filteredName(): string {
        return this.formGroup.get('name')?.value;
    }

    set showNotActived(values: boolean) {
        this.formGroup.get('showNotActived')?.setValue(values);
    }

    get showNotActived(): boolean {
        return this.formGroup.get('showNotActived')?.value;
    }

    removeToSelect(item: PossibleValuesFormField) {
        if (arrayIsSet(this.selectedOptions)) {
            const filteredregisterValues = this.selectedOptions.filter(option => option !== item.objectId);
            this.formGroup.get('options')?.setValue(filteredregisterValues);
        }
    }

    clickIcon() {
        this.formGroup.get('name')?.reset();
    }

    inSearchIn() {
        // this.openList = true;
        if (this.formGroup?.get('name')) {
            this.formGroup.get('name')?.updateValueAndValidity();
        }
    }

    clickOutside() {
        if (!this.disableClickOutside) {
            this.clickIcon();
        }
    }

    predicateFilterFunction(possibleValue: PossibleValuesFormField, filteredName: string, getTraduction: (v: string) => string): boolean {
        if (!arrayIsSet(Object.keys(possibleValue)) ||
            (!stringIsSet(possibleValue.traduction) && !stringIsSet(possibleValue.noTraduction)) ||
            !stringIsSet(filteredName)) {
            return false;
        } else {
            // tslint:disable-next-line:no-shadowed-variable
            const castValue = (value: string) => {
                return value
                    .replace(/_/g, ' ')
                    .replace(/-/g, ' ')
                    .replace(/\./g, '')
                    .trim()
                    .toLowerCase();
            };
            const isIncludes = (value1: string, value2: string) => {
                const castValue1 = castValue(value1);
                const castValue2 = castValue(value2);
                return castValue1.includes(castValue2);
            };
            const value = stringIsSet(possibleValue.traduction) ? getTraduction(possibleValue.traduction) : possibleValue.noTraduction!;
            return !isIncludes(value, filteredName);
        }
    }

    public predicateIsDisabled(possibleData: PossibleValuesFormField, actived: KeyStringValue<boolean>, disabled: KeyStringValue<boolean>) {
        if (possibleData) {
            if (actived != null) {
                return actived[possibleData.objectId] != true
            } else if (disabled) {
                return disabled[possibleData.objectId] == true
            }
        }
        return false
    }

    clickMostraNonAttivi() {
        this.showNotActived = !this.showNotActived;
    }




    getMenuIsOpen() {
        return this.trigger && this.trigger.menuOpen
    }

resetSlection(){
        this.formGroup.get('options')?.reset()
}

}
